import { useEffect, useRef, useState } from 'react';

import { Dayjs } from 'dayjs';

interface Options {
  enabled?: boolean;
  onEnd?: () => void;
}

const defaultOptions: Options = { enabled: true };

export const calculateMillisecondsToNow = (date: Dayjs) => Math.max(date.diff(), 0);

const useCountdown = (endDate: Dayjs, { enabled, onEnd } = defaultOptions) => {
  const endDateRef = useRef(endDate);
  const onEndRef = useRef(onEnd);
  const [remainingTimeInMs, setRemainingTimeInMs] = useState(calculateMillisecondsToNow(endDate));

  useEffect(() => {
    endDateRef.current = endDate;
  }, [endDate]);

  useEffect(() => {
    onEndRef.current = onEnd;
  }, [onEnd]);

  useEffect(() => {
    if (!enabled) return;
    const interval = setInterval(() => {
      const newRemainingTime = calculateMillisecondsToNow(endDateRef.current);
      setRemainingTimeInMs(newRemainingTime);
      if (newRemainingTime <= 0) {
        onEndRef.current?.();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [enabled]);

  return remainingTimeInMs;
};

export default useCountdown;
